/*
* This reducer file handles reducer's state for all actions that are related to system
*/
const initialState={
	logs: [],
	requesting: false
};
export default function systemReducer(state=initialState,action){
	switch(action.type)
	{
		case 'SYSTEM_LOG_REQUEST':
			return Object.assign({}, state, {
				logs: [],
				requesting: true,
		     });

		case 'SYSTEM_LOG_SUCCESS':
			return Object.assign({}, state, {
				logs: action.paylod,
				requesting: false,
		     });

		case 'SYSTEM_LOG_ERROR':
			return Object.assign({}, state, {
				logs: [],
				requesting: false,
		     });
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/Reducers/system.js